import { Stack, SxProps, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

type IInfoBanner = {
    backgroundColor: string,
    borderColor: string,
    textColor: string,
    icon?: JSX.Element,
    title?: string,
    label?: string
    sxContainer?: SxProps,
    id?: string,
    ariaLabel?: string
}

export const InfoBanner = ({ backgroundColor, borderColor, textColor, icon, title, label, sxContainer, id, ariaLabel }: IInfoBanner) => {
  const { t } = useTranslation();
  const slug = (id || title || label || "default")
    .toString()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/(^-|-$)/g, "") || "default";

  return (
    <Stack
      id={ `info-banner-${slug}` }
      data-testid="info-banner-container"
      role="region"
      aria-label={ ariaLabel || t("info_banner_aria_label") }
      sx={ {
        backgroundColor: backgroundColor,
        border: `0.06rem solid ${ borderColor }`,
        color: textColor,
        borderRadius: "0.25rem",
        padding: "0.75rem 1rem",
        alignItems: "center",
        ...sxContainer
      } }
      flexDirection={ "row" }
      alignItems={ "center" }
      gap={ "0.75rem" }
    >
      { icon && icon  }
      <Stack
        gap={ "0.5rem" }
      >
        { title && (
          <Typography
            data-testid="info-banner-title"
            color={ textColor }
            fontWeight={ 600 }
            fontSize={ "1rem" }
            lineHeight={ "1.188rem" }
            tabIndex={ 0 }
          >
            { title }
          </Typography>
        ) }
        { label &&
          <Typography
            data-testid="info-banner-label"
            color={ textColor }
            fontWeight={ 400 }
            fontSize={ "0.75rem" }
            lineHeight={ "1rem" }
            tabIndex={ -1 }
          >
            { label }
          </Typography>
        }
      </Stack>
    </Stack>
  );
};
